<template>
	<div
		class="booking-cms booking-fullwidth-cms"
		:class="[
			open_booking ? 'open_booking' : '',
			booking_object.layout.open,
			booking_object.layout.calendar === '1' ? 'one-calendar' : '',
			booking_object.layout.displayBottom ? 'displayBottom' : '',
		]"
		:style="stylesBooking"
		tabindex="-1"
		:inert="!open_booking"
	>
		<div class="booking-cms__content" :class="parseInt(booking_object.layout.calendar) == 2 ? 'double-calendar' : ''">
			<div class="booking-cms__header">
				<div>
					<booking-title v-if="booking_object.title.label !== ''" :config="booking_object.title"></booking-title>
					<booking-subtitle v-if="booking_object.subtitle.label !== ''" :config="booking_object.subtitle"></booking-subtitle>
				</div>

				<div @click="closeBooking" @keyup.enter="closeBooking" :style="styleCloseBooking" class="close-icon" tabindex="0">
					<img v-if="booking_object.icons.close !== ''" :src="booking_object.icons.close" alt="Close icon" />
					<span v-else>Close X</span>
				</div>
			</div>

			<div class="booking-cms__body">
				<div class="booking-cms__calendars">
					<booking-calendar
						:calendar="parseInt(booking_object.layout.calendar)"
						:stylesCalendar="booking_object.calendar"
						:bookingFieldsDate="booking_object.fields.children[0]"
						:minDate="booking_object.fields.children[0]['minDate']"
						:minDays="booking_object.fields.children[0]['minDays']"
						:dayNames="booking_object.fields.children[0]['dayNames']"
						:monthNames="booking_object.fields.children[0]['monthNames']"
						:template="booking_object.layout.template"
						:arrowIcon="booking_object.icons.arrow"
						:stylesInputCalendar="booking_object.fields.attributes"
						:showRates="showRates"
						:rates="booking_object.functionality.rates"
						@changeDates="changeDates"
					>
					</booking-calendar>
				</div>

				<div class="booking-cms__form">
					<form>
						<booking-fields
							:startDate="startDate"
							:endDate="endDate"
							:config="booking_object.fields"
							:icons="booking_object.icons"
							:backgroundColor="booking_object.layout.backgroundColor"
							template="fullwidth"
							:booking_data="booking_data"
						></booking-fields>

						<booking-button
							:booking_engine_site_setup="this.booking_engine_site_setup"
							:label="booking_object.button.label"
							:template="booking_object.layout.template"
							:attributes="booking_object.button.attributes"
						>
						</booking-button>
						<booking-button-modify v-if="booking_object.extras.extraLink !== ''" :extras="booking_object.extras" :styles="booking_object.fields.attributes" template="fullwidth">
						</booking-button-modify>
					</form>
				</div>

				<BookingBenefits v-if="booking_object.extras.benefits || booking_object.extras.benefits_title">
					<div v-if="booking_object.extras.benefits_title" :style="booking_object.subtitle.attributes" class="booking-cms__benefits-title">{{ booking_object.extras.benefits_title }}</div>
					<div :style="booking_object.benefits.attributes" class="booking-cms__benefits-content" v-html="booking_object.extras.benefits" />
				</BookingBenefits>
			</div>
		</div>
	</div>
</template>

<script>
import dayjs from 'dayjs';
import BookingSubtitle from '../partials/BookingSubtitle.vue';
import BookingTitle from '../partials/BookingTitle.vue';
import BookingCalendar from '../partials/BookingCalendar.vue';
import BookingFields from '../partials/BookingFields.vue';
import BookingButton from '../partials/BookingButton.vue';
import BookingButtonModify from '../partials/BookingButtonModify.vue';
import BookingBenefits from '../partials/BookingBenefits.vue';

export default {
	name: 'BookingFullwidth',
	components: {
		BookingTitle,
		BookingSubtitle,
		BookingCalendar,
		BookingFields,
		BookingButton,
		BookingButtonModify,
		BookingBenefits,
	},
	props: {
		booking_object: Object,
		booking_data: Object,
		open_booking: Boolean,
		showRates: Boolean,
		booking_engine_site_setup: String,
	},
	data() {
		return {
			startDate: '',
			endDate: '',
		};
	},
	methods: {
		closeBooking(event) {
			event.preventDefault();

			const closeIcon = document.querySelector('.booking-cms .close-icon');

			if (closeIcon && this.isElementVisible(closeIcon)) {
				this.$emit('close-booking');

				// Disable booking calendar tabindex and set focus on open booking button
				const bookingComponent = document.querySelector('.booking-cms');
				const bookingButton = document.querySelector('.bookingCMS');
				if (bookingComponent) bookingComponent.setAttribute('tabindex', '-1');
				if (bookingButton) bookingButton.focus();
			}
		},
		isElementVisible(el) {
			const rect = el.getBoundingClientRect();
			const viewHeight = Math.max(document.documentElement.clientHeight, window.innerHeight);
			return !(rect.bottom < 0 || rect.top >= viewHeight);
		},
		handleKeydown(event) {
			// keydown ESC
			if (this.open_booking && event.key === 'Escape') {
				this.closeBooking(event);
			}

			// keydown ARROW UP/DOWN and focus in .vfc-popover-container or some .vfc-span-day
			const calendarsElement = document.querySelector('.vfc-popover-container');
			const days = document.querySelectorAll('.vfc-span-day:not(.vfc-hide)'); // get all days elements (not hidden)
			const daysArray = Array.prototype.slice.call(days); // convert to array

			if (calendarsElement && (document.activeElement === calendarsElement || daysArray.includes(document.activeElement))) {
				// get the selected element index
				let index = daysArray.indexOf(document.activeElement);

				if (event.key === 'ArrowUp' || event.key === 'ArrowDown') {
					if (event.key === 'ArrowUp') {
						index--;
					} else if (event.key === 'ArrowDown') {
						index++;
					}

					// set the focus
					if (index >= 0 && index < days.length) {
						days[index].focus();
					}

					// reload the tabindex in all vfc-span-day if the focus was returned to main calendar (means that the page was changed)
					if (document.activeElement === calendarsElement) {
						this.reloadTabIndex();
					}
				} else if (event.key === 'ArrowLeft') {
					const arrowLeft = document.querySelector('.vfc-arrow-left');
					arrowLeft.click();
					calendarsElement.focus();
				} else if (event.key === 'ArrowRight') {
					const arrowRight = document.querySelector('.vfc-arrow-right');
					arrowRight.click();
					calendarsElement.focus();
				} else if (event.key === 'Enter') {
					days[index].click();
				} else if (event.key === 'Tab') {
					calendarsElement.focus();
				}
			}

			//console.log(document.activeElement);
		},
		changeDates(dates) {
			this.startDate = dates.start;
			this.endDate = dates.end ? dates.end : dayjs(dates.start, 'D-M-YYYY').add(1, 'day').format('D-M-YYYY');
		},
		reloadTabIndex() {
			// get all 'vfc-span-day' elements (not hidden)
			const calendarElements = document.querySelectorAll('.vfc-span-day:not(.vfc-hide)');

			// add tabindex in this elements
			calendarElements.forEach((element, index) => {
				element.setAttribute('tabindex', index + 1);
			});
		},
	},
	computed: {
		stylesBooking: function () {
			return {
				backgroundColor: this.booking_object.layout.backgroundColor,
				backgroundImage: `url(${this.booking_object.layout.backgroundImage})`,
				backgroundRepeat: 'repeat',
				backgroundSize: 'cover',
			};
		},
		styleCloseBooking: function () {
			return {
				color: this.booking_object.title.attributes.color,
				'--color-close': this.booking_object.title.attributes.color,
			};
		},
	},
	mounted() {
		document.addEventListener('keydown', this.handleKeydown);

		// set tabindex for all span-days elements
		this.reloadTabIndex();
	},
};
</script>

<style lang="scss">
.booking-cms {
	&.booking-fullwidth-cms.displayBottom {
		.booking-cms__header {
			display: block;
			text-align: center;
			.close-icon {
				position: absolute;
				top: 0;
				right: 0;
			}
		}
		.booking-cms__body {
			flex-direction: column;
		}
		.booking-cms__form {
			max-width: 740px;
			margin-left: 0;
			padding: 30px 0 0 0;
			form {
				display: flex;
				position: relative;
				align-items: end;
				justify-content: space-between;
			}
			.fields-container {
				display: flex;
				width: 80%;
			}
			.field-container.dates {
				display: flex;
				flex-flow: wrap;
				min-width: 45%;
				.field-date {
					margin: 0 10px;
					max-width: 150px;
				}
			}
			.field-container.col-6 {
				flex: 1 1;
			}

			.field-container {
				line-height: 1.5;
				width: auto;
				margin: 10px 1% 0px 1%;
			}

			.btn-booking-cms {
				margin: 10px 0 0 0;
			}
		}
	}
	.booking-cms__content {
		&.double-calendar {
			transform: translateY(-55%) !important;
			.booking-cms__header {
				& > div:first-child {
					width: 100%;
					text-align: center;
				}
			}
			.booking-cms__body {
				flex-direction: column;
				gap: 40px;
				align-items: center;
				justify-content: center;
			}
			.booking-cms__form {
				margin-left: 0;
				max-width: 730px;
				form {
					display: flex;
					align-items: center;
					justify-content: space-between;
					gap: 10px;
					.btn-booking-cms {
						margin: 0;
					}
				}
				.fields-container {
					display: flex;
					gap: 10px;
					flex-wrap: wrap;
					align-items: flex-end;
				}
				.field-container {
					margin: 0;
					&.col-12 {
						width: 52%;
						flex: 1;
						max-width: 340px;
					}
					&.col-3,
					&.col-6 {
						width: 80px;
					}
				}
			}
		}
	}
}
</style>
